import { ReactComponent as Loading } from './loading.svg';
import { ReactComponent as NotFound } from './../../Select/icons/not-found.svg';
import { ReactComponent as Clear } from './close.svg';
import { ReactComponent as Search } from './search.svg';
import { ReactComponent as DownArrow } from './arrow.svg';
import { ReactComponent as UpArrow } from './up-arrow.svg';
import { ReactComponent as Remove } from './remove.svg';
import { ReactComponent as TongyongJianTouYou } from './tongyong_jiantou_you.svg';
export { Loading, NotFound, Clear, Search, DownArrow, UpArrow, Remove, TongyongJianTouYou };
